import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ChileFlagIcon from '../assets/icons/flags/chile';
import MexicoFlagIcon from '../assets/icons/flags/mexico';
import SiiLogo from '../assets/icons/logos/sii';
import SatLogo from '../assets/icons/logos/sat';
import { REQUESTING_PLATFORM_TO_CODES } from '../constants/requesting-platform';
import getCdnUrl from './get-cdn-url';

const FingoImage = getCdnUrl('/logos/fingo-short-black@1x-70q.webp');

const spanishTranslations = {
  abandoned_shopping_cart_mail: 'carrito abandonado',
  invoice_reception_mail: 'facturas recibidas',
  invoice_rejection_mail: 'facturas rechazadas',
  approved_offers: 'facturas aprobadas',
  to_expire_offers: 'facturas por expirar',
  preoffer: 'pre oferta',
  never_evaluated: 'promociones de ofertas de tasa a usuarios nuevos',
};

const chileTranslations = {
  'National Tax Service': 'Servicio de Impuestos Internos',
  'National Tax Service credentials': 'Servicio de Impuestos Internos',
  'National Tax Service acronym': 'SII',
  'National Tax Service logo': SiiLogo,
  'National identifier': 'RUT',
  'Credential Password': 'Contraseña',
  'Phone prefix': '56',
  'Phone Number Length': 9,
  'account number': 'Número de la cuenta',
  'National tax service credential provider': 'Sii',
  'offer action': 'Empezar anticipo',
  'summary-preview-amount-title-available-factoring': 'Monto total facturas',
  'summary-preview-amount-title-mobile-available-factoring': 'Monto total',
  'summary-preview-button-text-available-offers': 'Empezar anticipo',
  'summary-preview-button-text-mobile-available-offers': 'Empezar anticipo',
  'default currency': 'CLP',
  'Price difference': 'Diferencia de precio',
  Direction: 'Av. Apoquindo 4660, Piso 8. Las Condes',
  retention: 'Retención (1%)',
  discount: '',
  quote: 'cotización',
  dte: 'Tipo',
  flag: ChileFlagIcon,
  'landing-path': 'https://fingo.cl',
  'Estados Financieros': 'Estados Financieros',
  'offer third step': 'Cede tus facturas',
  'Processing invoice': 'Procesando cesión',
  'Processing completed': 'Cedida',
  'reference rate': 'Tasa referencial',
  'internal-cession-recommended-title': 'Te recomendamos ceder desde Fingo:',
  'internal-cession-label': 'Cede desde Fingo',
  'internal-cession-image': FingoImage,
  'internal-cession-description': 'Hacemos la cesión por ti. Solo necesitas:',
  'external-cession-label': 'Cede desde tu facturador',
  'external-cession-description': 'Cede manualmente desde tu facturador',
  'operation-confirmation-subtitle': 'Te notificaremos cuando se realice el giro.',
  'operation-confirmation-button-label': 'Entendido',
  'lucila-logo': 'images/logos/lucila-logo.png',
  SANTANDER: 'Santander',
  BCH: 'Banco de Chile',
  'pricing-rules': 'Reglas',
  'external-risk-classification-adjustment': 'Ajuste por clasificación (Tasa)',
  ...spanishTranslations,
};

const mexicoTranslations = {
  'National Tax Service': 'Servicio de Administración Tributaria',
  'National Tax Service credentials': 'SAT (CIEC)',
  'National Tax Service acronym': 'SAT',
  'National Tax Service logo': SatLogo,
  'National identifier': 'RFC',
  'Credential Password': 'CIEC',
  'default currency': 'MXN',
  'Phone prefix': '52',
  'Phone Number Length': 10,
  'National tax service credential provider': 'Sat',
  'account number': 'Cuenta CLABE',
  'offer action': 'Empezar anticipo',
  'Price difference': 'Interés',
  Direction: 'Varsovia No. 36 Int Piso 4, Int. 408, Colonia Juárez C.p. 6600 Alcaldía: Cuauhtémoc Entidad Federativa: Ciudad De México',
  retention: 'Monto retenido por aforo',
  discount: '-',
  quote: 'operación',
  dte: 'Efecto',
  flag: MexicoFlagIcon,
  'landing-path': 'https://www.fingo.com.mx/',
  'Estados Financieros': 'Estados de resultados',
  'offer third step': 'Cede derechos de cobro',
  'Processing invoice': 'En proceso de firma',
  'Processing completed': 'Anexo firmado',
  'reference rate': 'Tasa referencial',
  ...spanishTranslations,
};

i18n.use(initReactI18next).init({
  resources: {
    Chile: {
      translation: chileTranslations,
    },
    Mexico: {
      translation: mexicoTranslations,
    },
    [REQUESTING_PLATFORM_TO_CODES.BCH]: {
      translation: {
        ...chileTranslations,
        'reference rate': 'Tasa operación',
        'internal-cession-recommended-title': 'Te recomendamos ceder de forma automática:',
        'internal-cession-label': 'Cede de forma automática',
        'internal-cession-image': null,
        'internal-cession-description': 'El sistema se encarga de la gestión. Sólo necesitas:',
        'external-cession-label': 'Manualmente desde tu facturador',
        'external-cession-description': 'Completa el formulario de cesión en tu facturador',
        'operation-confirmation-subtitle': 'Te notificaremos cuando se realice el giro, el cual se realizará a tu cuenta bancaria del Banco de Chile.',
        'operation-confirmation-button-label': 'Ir a mis operaciones',
        'lucila-logo': 'images/logos/backoffice-by-fingo.webp',
      },
    },
    [REQUESTING_PLATFORM_TO_CODES.ITAU]: {
      translation: {
        ...chileTranslations,
        'pricing-rules': 'Spreads',
        'external-risk-classification-adjustment': 'Spread',
        'summary-preview-amount-title-available-factoring': 'Monto a cotizar',
        'summary-preview-amount-title-mobile-available-factoring': 'Monto a cotizar',
        'summary-preview-button-text-available-offers': 'Solicitar financiamiento',
        'summary-preview-button-text-mobile-available-offers': 'Solicitar',
        'lucila-logo': 'images/logos/backoffice-by-fingo.webp',
      },
    },
  },
  lng: 'Chile',
  fallbackLng: 'Chile',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
